import VMasker from 'vanilla-masker'

export const toFormat = (value, maskFunction) => {
  if (value === null || value === undefined) return ''

  if (!maskFunction) return ''

  return maskFunction(value)
}

export const toFormatPhone = (value) =>
  toFormat(value, (verifiedValue) =>
    VMasker.toPattern(verifiedValue, '(99) 9999-9999')
  )

export const toFormatPhoneComplete = (value) =>
  toFormat(value, (verifiedValue) =>
    VMasker.toPattern(verifiedValue, '+99 (99) 99999-9999')
  )

export const formatCNPJ = (value) => {
  if (!value) return null
  const x = value
    .replace(/\D/g, '')
    .match(/(\d{0,2})(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,2})/)

  return !x[2]
    ? x[1]
    : `${x[1]}.${x[2]}.${x[3]}.${x[4]}${x[5] ? `/${x[5]}` : ''}`
}
